export const CONTACT = {
    SET_SITE: 'CONTACT_SET_SITE',
    SET_INTERLOCUTEUR: 'CONTACT_SET_INTERLOCUTEUR',
    SET_OBJET: 'CONTACT_SET_OBJET',
    SET_DESCRIPTION: 'CONTACT_SET_DESCRIPTION',
    SET_INTERLOCUTEURS_LOADING: 'CONTACT_SET_LOADING',
    SET_LISTE_INTERLOCUTEURS: 'CONTACT_SET_LISTE_INTERLOCUTEURS',
    SET_MESSAGE_SENDING: 'CONTACT_SET_MESSAGE_SENDING',
    SET_IS_SUCCESS: 'CONTACT_SET_IS_SUCCESS',
    RESET: 'CONTACT_RESET',
    NEXT_STEP: 'CONTACT_NEXT_STEP',
    PREVIOUS_STEP: 'CONTACT_PREVIOUS_STEP',
    EXPORT_LOADING: 'EXPORT_LOADING'
};
